export default __webpack_public_path__ + "static/media/background.ecdc1c7c.png";